
    

<div class="drag-drop-zone" [class.is-dragging]="isDragging" (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <p>Drag and drop files here or click to browse</p>
  <input type="file" #fileInput (change)="onFileSelected($event)" multiple [accept]="getAllowedFileTypesString()" style="display: none;">
  <button mat-raised-button color="primary" (click)="fileInput.click()"><mat-icon fontSet="material-symbols-outlined">folder_open</mat-icon> Browse Files</button>
</div>
<!-- Progress bar - only show during upload -->
@if(isBusy){
<div class="progress-section">
  <mat-progress-bar mode="determinate" [value]="uploadProgress" color="primary">
  </mat-progress-bar>
  <div class="progress-text">
    Uploading... {{uploadProgress}}%
  </div>
</div>
}
@if(errorMessage){
<div class="error-message m-t-1">
  <mat-error>{{errorMessage}}</mat-error>
</div>
}
@if(files.length > 0){
<div class="selected-files m-t-1">
  @for (file of files; track $index) {
  <mat-card class="file-panel m-b-1">
    <mat-card-content class="d-flex">
      <div class="file-icon"><mat-icon fontSet="material-symbols-outlined" class="upload">attach_file</mat-icon></div>
      <div class="file-info">{{getTruncatedFileName(file.name)}}</div>
      <div class="file-size">({{file.size | byteFormat}})</div>
      <div class="file-actions"><button mat-icon-button (click)="removeOne($index)" aria-label="Remove file"><mat-icon
            fontSet="material-symbols-outlined" class="delete">delete</mat-icon></button></div>

    </mat-card-content>
  </mat-card>
  }
</div>
}


<mat-dialog-actions align="center">
  <button mat-flat-button type="button" (click)="uploadFiles()"
    [disabled]="files.length === 0 || isBusy || uploadDisabled"><mat-icon fontSet="material-symbols-outlined">upload</mat-icon> Upload</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="removeAll()" [disabled]="removeDisabled || isBusy"><mat-icon fontSet="material-symbols-outlined">close</mat-icon> Remove
    All</button>
  @if (isBusy) {  <button mat-flat-button class="cancel-button" type="button" (click)="cancelUpload()">Cancel Upload</button>
  }

</mat-dialog-actions>